package navigation.home.allitinerary

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryEvent
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryState
import com.essntl.features.itinerary.ui.all_itinerary.AllItineraryViewModel
import com.essntl.features.profile.domain.repository.ProfileRepository

class AllItineraryScreenModel(
    itineraryRepository: ItineraryRepository,
    areaRepository: AreaRepository,
    profileRepository: ProfileRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllItineraryState>(AllItineraryState()) {
    private val vm =
        AllItineraryViewModel(
            itineraryRepository = itineraryRepository,
            areaRepository = areaRepository,
            profileRepository = profileRepository,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllItineraryEvent) = vm.onEvent(event)
}
